export const OFF = 'OFF';
export const PREPARING = 'PREPARING';
export const RECORDING = 'RECORDING';
export const STOPPING = 'STOPPING';

